import { render, staticRenderFns } from "./HelpText.vue?vue&type=template&id=5bbb3038&scoped=true&lang=pug&"
import script from "./HelpText.vue?vue&type=script&lang=js&"
export * from "./HelpText.vue?vue&type=script&lang=js&"
import style0 from "./HelpText.vue?vue&type=style&index=0&id=5bbb3038&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbb3038",
  null
  
)

export default component.exports